// class DropdownLocalizationComponent extends HTMLElement {
//   connectedCallback() {
//     this.button = this.querySelector('[ref="button"]');
//     this.panel = this.querySelector('[ref="panel"]');

//     // Open/close dropdown
//     this.button?.addEventListener('click', () => this.toggleSelector());

//     // Close when clicking outside
//     document.addEventListener('click', (e) => {
//       if (!this.contains(e.target)) this.closeSelector();
//     });

//     // Submit form when a currency/language is clicked
//     this.panel?.addEventListener('click', (e) => {
//       const item = e.target.closest('a, button, .localization-form__select, [data-value]');
//       if (!item) return;
//       const form = this.querySelector('form');
//       if (form) form.submit();
//     });
//   }

//   toggleSelector() {
//     const isOpen = this.button.getAttribute('aria-expanded') === 'true';
//     isOpen ? this.closeSelector() : this.openSelector();
//   }

//   openSelector() {
//     this.button.setAttribute('aria-expanded', 'true');
//     this.panel?.removeAttribute('hidden');
//   }

//   closeSelector() {
//     this.button.setAttribute('aria-expanded', 'false');
//     this.panel?.setAttribute('hidden', '');
//   }
// }

// if (!customElements.get('dropdown-localization-component')) {
//   customElements.define('dropdown-localization-component', DropdownLocalizationComponent);
// }


// class DropdownLocalizationComponent extends HTMLElement {
//   connectedCallback() {
//     this.button = this.querySelector('[ref="button"]');
//     this.panel = this.querySelector('[ref="panel"]');

//     // Open/close dropdown
//     this.button?.addEventListener('click', () => this.toggleSelector());

//     // Close when clicking outside
//     document.addEventListener('click', (e) => {
//       if (!this.contains(e.target)) this.closeSelector();
//     });

//     // Submit form when a country item is clicked
//     this.panel?.addEventListener('click', (e) => {
//       const item = e.target.closest('[data-value]');
//       if (!item) return;

//       const countryCode = item.dataset.value;
//       if (!countryCode) return;

//       const countryInput = this.querySelector('[ref="countryInput"]');
//       const form = this.querySelector('form');

//       if (countryInput && form) {
//         countryInput.value = countryCode;  // ✅ Set correct country first
//         form.submit();                      // ✅ Then submit
//       }
//     });
//   }

//   toggleSelector() {
//     const isOpen = this.button.getAttribute('aria-expanded') === 'true';
//     isOpen ? this.closeSelector() : this.openSelector();
//   }

//   openSelector() {
//     this.button.setAttribute('aria-expanded', 'true');
//     this.panel?.removeAttribute('hidden');
//   }

//   closeSelector() {
//     this.button.setAttribute('aria-expanded', 'false');
//     this.panel?.setAttribute('hidden', '');
//   }
// }

// if (!customElements.get('dropdown-localization-component')) {
//   customElements.define('dropdown-localization-component', DropdownLocalizationComponent);
// }

class DropdownLocalizationComponent extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[ref="button"]');
    this.panel = this.querySelector('[ref="panel"]');

    this.button?.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleSelector();
    });

    // ✅ Handle country clicks manually since on:click framework isn't active
    this.panel?.addEventListener('click', (e) => {
      const item = e.target.closest('[data-value]');
      if (!item) return;

      const countryCode = item.dataset.value;
      if (!countryCode) return;

      // ✅ Find countryInput by ref attribute
      const countryInput = this.querySelector('[ref="countryInput"]');
      const form = this.querySelector('form');

      if (countryInput && form) {
        countryInput.value = countryCode;
        form.submit();
      }
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.closeSelector();
    });
  }

  toggleSelector() {
    const isOpen = this.button.getAttribute('aria-expanded') === 'true';
    isOpen ? this.closeSelector() : this.openSelector();
  }

  openSelector() {
    this.button.setAttribute('aria-expanded', 'true');
    this.panel?.removeAttribute('hidden');
  }

  closeSelector() {
    this.button.setAttribute('aria-expanded', 'false');
    this.panel?.setAttribute('hidden', '');
  }
}

if (!customElements.get('dropdown-localization-component')) {
  customElements.define('dropdown-localization-component', DropdownLocalizationComponent);
}